import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

const INACTIVITY_LIMIT = 60 * 1000 * 60; // 60 minutes

const InactivityTimer = ({ logout }) => {
    const history = useHistory();
    const timerRef = useRef();

    const resetTimer = () => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            logout({ returnTo: window.location.origin });
            setTimeout(() => {
                window.location.reload(); // Force full reload after logout
            }, 500);
        }, INACTIVITY_LIMIT);
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
        events.forEach(event => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            clearTimeout(timerRef.current);
            events.forEach(event => window.removeEventListener(event, resetTimer));
        };
    }, [logout, history]);
    return null;
};

export default InactivityTimer;